import { render, staticRenderFns } from "./ListDiscountAddition.vue?vue&type=template&id=ded3b47e"
import script from "./ListDiscountAddition.vue?vue&type=script&lang=js"
export * from "./ListDiscountAddition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports